module.exports = __webpack_public_path__ + "static/img/blue.880ab34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blue.png
// module id = aSq4
// module chunks = 0